
import { memo } from 'react'

import { FriendlyDateTime } from '../shared/Date/friendly-date-time'
import UserName from '../shared/User/UserName'
import UserRoles from '../shared/User/UserRoles'

const EncounterNarrative = memo(({ encounter }) => {
  const { user } = encounter.document
  return (
    <div>
      <h2>Narrative</h2>
      <div
        className='narrative-content'
        style={{ maxWidth: '45em' }}
      >
        <p>{encounter.document.narrative}</p>
        <p className='nh-narrative-timestamp'>
          Electronically signed by&nbsp;
          <UserName user={user} />
          ,&nbsp;
          <UserRoles user={user} />
          &nbsp;at&nbsp;
          <FriendlyDateTime datetime={encounter.updated_at} />
        </p>
      </div>
    </div>
  )
})

EncounterNarrative.displayName = 'EncounterNarrative'

export default EncounterNarrative
